import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ListadoComprasDirectas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COMPRAS_DIRECTAS = process.env.REACT_APP_URL_COMPRAS_DIRECTAS;
  const URL_COMPRAS_DIRECTAS_ACUMULADOS = process.env.REACT_APP_URL_COMPRAS_DIRECTAS_ACUMULADOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [fecha, setFecha] = useState("");
  const [factura_proveedor, setFacturaProveedor] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [pais_origen, setPaisOrigen] = useState("");
  const [numero_compra, setNumeroCompra] = useState("");
  const [idEdit, setIdEdit] = useState("");

  const [articulosFaltante, setArticulosFaltante] = useState([]);
  const [totalFaltante, setTotalFaltante] = useState(0);
  const [modalFaltante, setModalFaltante] = useState(false);
  const toggleFaltante = () => setModalFaltante(!modalFaltante);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_COMPRAS_DIRECTAS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCompras = response.data;
        // Array para pagination
        let arrayTabla = allCompras
          .filter(
    (a) =>
      Array.isArray(a.ordenesCorteExterno) &&
      a.ordenesCorteExterno.length > 0 &&
      a.ordenesCorteExterno[0]?.proveedores?.[0]
  )
  .sort((a, b) =>
    a.idComprasDirectas > b.idComprasDirectas ? 1 : -1
  )
          .map((a) => {
            return {
              activo: a.is_active,
              _id: a._id,
              numero: a.idComprasDirectas,
              fecha: a.fecha,
              observaciones: a.observaciones,
              piezas: a.total_piezas.toFixed(2),
              factura_proveedor: a.factura_proveedor,
              iduser: a.user[0]._id,
              user: a.user[0].nombre + " " + a.user[0].apellido,
              pais_origen: a.pais_origen,
              total_costo: a.total_costo,
              subtotal: a.subtotal,
              iva: a.iva,
              idOrdenesCompra: a.ordenesCorteExterno[0]._id,
              numeroOrden: a.ordenesCorteExterno[0].idOrdenesCorteExterno,
              fecha_orden_compra: a.ordenesCorteExterno[0].fecha,
              proveedores: a.ordenesCorteExterno[0].proveedores[0].razon_social,
              idProveedores: a.ordenesCorteExterno[0].proveedores[0]._id,
              idOrdenCompra: a.ordenesCorteExterno[0]._id,
              tipo: a.ordenesCorteExterno[0].tipo,
              observacionesOrden: a.ordenesCorteExterno[0].observaciones,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const ListaCompras = comments.sort((a, b) =>
    a.idCompras > b.idCompras ? 1 : -1
  );

  function PDFTabla() {
    const data = ListaCompras.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.proveedores,
          a.factura_proveedor,
          a.pais_origen,
          a.numeroOrden,
          new Intl.NumberFormat("en-US").format(a.kilos),
          new Intl.NumberFormat("en-US").format(a.metros),
          new Intl.NumberFormat("en-US").format(a.piezas),
          a.user,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado de Compras`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Proveedor",
          "Factura Proveedor",
          "Pais Origen",
          "OC",
          "Kilos",
          "Metros",
          "Piezas",
          "Recibio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Compras.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = ListaCompras.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return {
          Activo: a.activo,
          Numero: a.numero,
          Fecha: a.fecha,
          Proveedores: a.proveedores,
          Factura: a.factura_proveedor,
          Pais: a.pais_origen,
          OC: a.numeroOrden,
          Kilos: a.kilos,
          Metros: a.metros,
          Piezas: a.piezas,
          Recibio: a.user,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoComprasDirectas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoComprasDirectas",
        sheetFilter: [
          "Activo",
          "Numero",
          "Fecha",
          "Proveedor",
          "Factura",
          "Pais",
          "OC",
          "Kilos",
          "Metros",
          "Piezas",
          "Recibio",
        ],
        sheetHeader: [
          "Activo",
          "Numero",
          "Fecha",
          "Proveedor",
          "Factura",
          "Pais",
          "OC",
          "Kilos",
          "Metros",
          "Piezas",
          "Recibio",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaCompras.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedores)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.proveedores,
          a.factura_proveedor,
          a.pais_origen,
          a.numeroOrden,
          new Intl.NumberFormat("en-US").format(a.kilos),
          new Intl.NumberFormat("en-US").format(a.metros),
          new Intl.NumberFormat("en-US").format(a.piezas),
          a.user,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado de Compras`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Proveedor",
          "Factura Proveedor",
          "Pais Origen",
          "OC",
          "Kilos",
          "Metros",
          "Piezas",
          "Recibio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = doc.output("datauristring").split(",")[1];

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Compras",
          email: mailTo,
          fileName: "ListadoComprasDirectas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Compras.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    factura_proveedor,
    observaciones,
    numero,
    pais_origen,
    idEdit
  ) {
    setFecha(fecha);
    setFacturaProveedor(factura_proveedor);
    setObservaciones(observaciones);
    setNumeroCompra(numero);
    setPaisOrigen(pais_origen);
    setIdEdit(idEdit);
    toggleEdit();
  }


async function PDFOCResumen(fecha, proveedores, numero, ivaPDF, totalPDF, idPDFOC) {
  try {
    const { data: allTelasCompra } = await axios.get(
      `${URL_COMPRAS_DIRECTAS_ACUMULADOS}/compra/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // Agrupamos por sucursal > área > artículos
    const agrupado = {};

    allTelasCompra.forEach((a) => {
      const sucursal = a.sucursales?.[0]?.alias || "Sin Sucursal";
      const area = a.areasClientes?.[0]?.name || "Sin Área";
      const articulo = `${a.articulos?.[0]?.codigo || ""} ${a.articulos?.[0]?.descripcion || ""}`;

      if (!agrupado[sucursal]) agrupado[sucursal] = {};
      if (!agrupado[sucursal][area]) agrupado[sucursal][area] = {};
      if (!agrupado[sucursal][area][articulo]) {
        agrupado[sucursal][area][articulo] = {
          cantidad: 0,
          precio: a.precio || 0,
        };
      }

      agrupado[sucursal][area][articulo].cantidad += a.cantidad || 0;
    });

    // PDF
    const doc = new jsPDF(); // Portrait por defecto
    const pageWidth = doc.internal.pageSize.getWidth();

    // ✅ Función utilitaria para cargar imágenes de forma segura
    function loadImageAsPromise(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    }

    // ✅ Cargar imágenes
    const logoLynqro = await loadImageAsPromise(process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png");
    const logoInstitucion = await loadImageAsPromise(process.env.PUBLIC_URL + "logoInstitucion.png");

    // ✅ Agregar imágenes (ajustadas)
    {
      const scale1 = 10 / logoLynqro.height;
      const width1 = logoLynqro.width * scale1;
      const height1 = logoLynqro.height * scale1;
      const x1 = pageWidth - width1 - 15;
      doc.addImage(logoLynqro, "PNG", x1, 10, width1, height1);
    }

    {
      const scale2 = 20 / logoInstitucion.height;
      const width2 = logoInstitucion.width * scale2;
      const height2 = logoInstitucion.height * scale2;
      const x2 = pageWidth - width2 - 15;
      doc.addImage(logoInstitucion, "PNG", x2, 25, width2, height2);
    }

    doc.setFontSize(12);
    doc.text(`Compra # ${numero}`, 20, 20);
    doc.text(`Fecha: ${fecha}`, 20, 25);
    doc.text(`Proveedor: ${proveedores}`, 20, 30);

    let currentY = 50;
    let totalPiezas = 0;
    let subtotal = 0;

    for (const sucursal of Object.keys(agrupado)) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.text(`Sucursal: ${sucursal}`, 20, currentY);
      currentY += 6;

      for (const area of Object.keys(agrupado[sucursal])) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(10);
        doc.text(`Área: ${area}`, 30, currentY);
        currentY += 5;

        const body = [];
        for (const articulo of Object.keys(agrupado[sucursal][area])) {
          const { cantidad, precio } = agrupado[sucursal][area][articulo];
          const total = cantidad * precio;
          totalPiezas += cantidad;
          subtotal += total;

          body.push([
            articulo,
            new Intl.NumberFormat("en-US").format(cantidad),
            `$${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(precio)}`,
            `$${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total)}`,
          ]);
        }

        doc.autoTable({
          head: [["Artículo", "Cantidad", "Precio", "Total"]],
          body,
          startY: currentY,
          styles: {
            fontSize: 9,
            cellPadding: 1.5,
          },
        });

        currentY = doc.autoTable.previous.finalY + 10;
        if (currentY > 180) {
          doc.addPage();
          currentY = 20;
        }
      }
    }

    // Resumen — IVA real de la compra (0 = sin impuestos); no calcular fallback fantasma
    const iva = Number(ivaPDF) || 0;
    const totalFinal = Number(totalPDF) || subtotal + iva;
    const fmtM = (n) =>
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(n) || 0);

    doc.setFontSize(11);
    if (currentY + 30 > 190) {
      doc.addPage();
      currentY = 20;
    }

    doc.setFont(undefined, "bold");
    doc.text(`Resumen General`, 20, currentY);
    currentY += 6;
    doc.setFont(undefined, "normal");
    doc.text(`Piezas: ${totalPiezas}`, 20, currentY);
    currentY += 6;
    doc.text(`SubTotal: $${fmtM(subtotal)}`, 20, currentY);
    currentY += 6;
    if (iva > 0) {
      doc.text(`IVA: $${fmtM(iva)}`, 20, currentY);
      currentY += 6;
    }
    doc.text(`Total: $${fmtM(totalFinal)}`, 20, currentY);

    // Abrir PDF
    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

function jalaPDFOC(fecha, proveedores, numero, ivaPDF, totalPDF, idPDFOC) {
    // sweetalert2 v9 no soporta showDenyButton (v10+). Usamos:
    //   confirmar = "Sí, con totales"  ·  cancelar = "No, sin totales"
    //   (ESC o clic fuera = no genera nada)
    Swal.fire({
      title: "¿Incluir el resumen general?",
      text: "El resumen muestra piezas totales, subtotal, IVA y total.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, con totales",
      cancelButtonText: "No, sin totales",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#0ea5e9",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        PDFOC(fecha, proveedores, numero, ivaPDF, totalPDF, idPDFOC, true);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        PDFOC(fecha, proveedores, numero, ivaPDF, totalPDF, idPDFOC, false);
      }
    });
  }

async function PDFOC(fecha, proveedores, numero, ivaPDF, totalPDF, idPDFOC, conResumen = true) {
  try {
    const { data: acumulados } = await axios.get(
      `${URL_COMPRAS_DIRECTAS_ACUMULADOS}/compra/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];

    const isSinVar = (v) => {
      const t = String(v || "").trim().toLowerCase();
      return !t || t === "sin variante" || t === "na";
    };

    // L45 (2026-06) — landscape + paleta + variantes como sub-row del color
    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginRight = 15;
    const marginBottom = 12;

    const brandColor = [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = String(value ?? "").trim();
      doc.text(txt || "—", valX, y);
    };

    function loadImageAsPromise(src) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = src;
      });
    }

    const logoInstitucion = await loadImageAsPromise(
      process.env.PUBLIC_URL + "logoInstitucion.png"
    );

    if (logoInstitucion) {
      const maxH = 16;
      const scale = maxH / logoInstitucion.height;
      doc.addImage(logoInstitucion, "PNG", marginLeft, 8, logoInstitucion.width * scale, maxH);
    }

    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`COMPRA DIRECTA # ${numero}`, pageWidth - marginRight, 18, { align: "right" });
    doc.setTextColor(0);

    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, 28, pageWidth - marginRight, 28);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    const cardY = 31;
    const cardW = pageWidth - marginLeft - marginRight;
    const cardH = 18;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    drawLabel("Fecha:", fecha, marginLeft + 3, marginLeft + 28, cardY + 6);
    drawLabel("Proveedor:", proveedores, marginLeft + 3, marginLeft + 28, cardY + 12);
    drawLabel("Compra #:", numero, pageWidth / 2 + 5, pageWidth / 2 + 30, cardY + 6);

    let currentY = cardY + cardH + 6;

    const estructura = {};
    const tallasSet = new Set();

    acumulados.forEach((a) => {
      const area = a.areasClientes?.[0]?.name || "Sin Área";
      const articulo = `${a.articulos?.[0]?.codigo || ""} ${
        a.articulos?.[0]?.descripcion || ""
      }`.trim() || "Sin Artículo";
      const color = a.colores?.[0]?.name || "Sin color";
      const tallaBase = (a.tallas?.[0]?.name || "Sin talla").trim();
      const varianteRaw = (a.tallas?.[0]?.variantesTallas?.[0]?.name || "").trim();
      const variante = varianteRaw || "Sin variante";
      const cantidad = a.cantidad || 0;

      tallasSet.add(tallaBase);

      if (!estructura[area]) estructura[area] = {};
      if (!estructura[area][articulo]) estructura[area][articulo] = {};
      if (!estructura[area][articulo][color]) estructura[area][articulo][color] = {};
      if (!estructura[area][articulo][color][variante]) estructura[area][articulo][color][variante] = {};

      estructura[area][articulo][color][variante][tallaBase] =
        (estructura[area][articulo][color][variante][tallaBase] || 0) + cantidad;
    });

    const tallasOrdenadas = Array.from(tallasSet).sort((a, b) => {
      const indexA = ordenTallas.indexOf(a);
      const indexB = ordenTallas.indexOf(b);
      return (
        (indexA === -1 ? Infinity : indexA) -
        (indexB === -1 ? Infinity : indexB)
      );
    });

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = 20;
      }
    };

    let totalPiezas = 0;

    for (const area of Object.keys(estructura)) {
      ensureRoom(14);
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, cardW, 9, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.text(`ÁREA: ${area}`, marginLeft + 3, currentY + 6.3);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += 12;

      for (const articulo of Object.keys(estructura[area])) {
        ensureRoom(18);
        doc.setFillColor(225, 232, 240);
        doc.rect(marginLeft, currentY, cardW, 7, "F");
        doc.setDrawColor(...brandColor);
        doc.setLineWidth(0.3);
        doc.line(marginLeft, currentY + 7, pageWidth - marginRight, currentY + 7);
        doc.setLineWidth(0.2);
        doc.setDrawColor(0);
        doc.setTextColor(...brandColor);
        doc.setFont(undefined, "bold");
        doc.setFontSize(10);
        doc.text(`Modelo: ${articulo}`, marginLeft + 3, currentY + 5);
        doc.setTextColor(0);
        doc.setFont(undefined, "normal");
        currentY += 10;

        const dataColor = estructura[area][articulo];
        // Solo mostrar las tallas con al menos una cantidad > 0 en esta tabla
        // (omite columnas como "POR DEFINIR" cuando están vacías/en 0).
        const tallasVisibles = tallasOrdenadas.filter((talla) =>
          Object.keys(dataColor).some((color) =>
            Object.keys(dataColor[color]).some(
              (variante) => (dataColor[color][variante][talla] || 0) > 0
            )
          )
        );
        const head = [["Color / Variante", ...tallasVisibles, "Total"]];
        const body = [];

        for (const color of Object.keys(dataColor)) {
          const variantesRaw = Object.keys(dataColor[color]);
          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);
            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;
            return String(a).localeCompare(String(b), "es", { numeric: true });
          });
          let firstVar = true;
          for (const variante of variantes) {
            const tituloVar = isSinVar(variante) ? "" : variante;
            const colorTxt = firstVar ? color : "";
            const row = [];
            row.push(
              tituloVar
                ? colorTxt
                  ? `${colorTxt}\n${tituloVar}`
                  : tituloVar
                : colorTxt || ""
            );

            let totalPorRow = 0;
            for (const talla of tallasVisibles) {
              const cantidad = dataColor[color][variante][talla] || 0;
              row.push(cantidad > 0 ? String(cantidad) : "");
              totalPorRow += cantidad;
            }

            row.push(String(totalPorRow));
            totalPiezas += totalPorRow;
            body.push(row);
            firstVar = false;
          }
        }

        ensureRoom(20);
        doc.autoTable({
          head,
          body,
          startY: currentY,
          margin: { left: marginLeft, right: marginRight },
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          columnStyles: {
            0: { halign: "left", cellWidth: 36 },
          },
          didParseCell: (h) => {
            if (h.section === "body" && h.column.index === 0) {
              const raw = h.cell.raw;
              const txt = typeof raw === "string" ? raw : raw?.content || "";
              if (txt && String(txt).includes("\n")) {
                h.cell.styles.fontStyle = "bold";
              }
            }
            if (h.section === "body" && h.column.index === h.row.cells.length - 1) {
              h.cell.styles.fontStyle = "bold";
              h.cell.styles.textColor = brandColor;
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        ensureRoom(4);
        doc.setDrawColor(...borderColor);
        doc.line(marginLeft, currentY, pageWidth - marginRight, currentY);
        doc.setDrawColor(0);
        currentY += 4;
      }
    }

    // Resumen general OPCIONAL: el usuario elige Sí/No en un modal antes de generar el PDF
    if (conResumen) {
    // IVA y total reales de la compra directa (a.iva puede ser 0 = sin impuestos).
    // NO calcular fallback: antes usaba `totalPiezas * 0.16` (nº de piezas × 0.16),
    // que generaba un IVA fantasma cuando la compra no tiene impuestos.
    const iva = Number(ivaPDF) || 0;
    const totalFinal = Number(totalPDF) || 0;

    ensureRoom(40);
    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.setTextColor(...brandColor);
    doc.text("RESUMEN GENERAL", pageWidth - marginRight, currentY, { align: "right" });
    doc.setTextColor(0);
    currentY += 3;

    const fmt = (n) =>
      "$" +
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(n) || 0);
    const resumenRows = [
      ["Piezas totales", `${totalPiezas}`],
      ["Subtotal", fmt(totalFinal - iva)],
      // Solo se muestra la línea de IVA si la compra realmente lo tiene
      ...(iva > 0 ? [["IVA (16%)", fmt(iva)]] : []),
      ["Total", fmt(totalFinal)],
    ];

    const resumenW = 95;
    const resumenLabelW = 45;
    const resumenX = pageWidth - marginRight - resumenW;

    doc.autoTable({
      startY: currentY,
      margin: { left: resumenX, right: marginRight },
      tableWidth: resumenW,
      body: resumenRows,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 1.5,
        lineColor: borderColor,
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: resumenLabelW, fillColor: lightBg, textColor: labelColor, fontStyle: "bold" },
        1: { cellWidth: resumenW - resumenLabelW, halign: "right" },
      },
      didParseCell: (h) => {
        if (h.row.index === resumenRows.length - 1) {
          h.cell.styles.fillColor = brandColor;
          h.cell.styles.textColor = [255, 255, 255];
          h.cell.styles.fontStyle = "bold";
          h.cell.styles.fontSize = 11;
        }
      },
    });
    }

    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Compra Directa #${numero}  ·  ${proveedores}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

  function editCompras(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_COMPRAS_DIRECTAS}/${idEdit}`,
        {
          fecha,
          factura_proveedor,
          observaciones,
          pais_origen,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Compra",
            detalle: `${numero_compra} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "OC", field: "numeroOrden", sortable: true },
    // { name: "Observaciones OC", field: "observacionesOrden", sortable: true },
    { name: "Proveedor", field: "proveedores", sortable: true },
    // { name: "Kilos", field: "kilos", sortable: true },
    // { name: "Metros", field: "metros", sortable: true },
    { name: "Piezas", field: "piezas", sortable: true },
    { name: "Subtotal", field: "subtotal", sortable: true },
    { name: "IVA", field: "iva", sortable: true },
    { name: "Total", field: "total_costo", sortable: true },
    { name: "Recibio", field: "user", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      // (2026-10) Los renglones no traen kilos ni metros: `undefined.toString()`
      // tronaba el filtro en cuanto lo escrito no coincidía con los primeros
      // campos. Se busca en todo lo que se ve en la tabla, sin importar el tipo.
      const q = search.toLowerCase();
      computedComments = computedComments.filter((comment) =>
        [
          comment.activo,
          comment.numero,
          comment.fecha,
          comment.numeroOrden,
          comment.proveedores,
          comment.piezas,
          comment.subtotal,
          comment.iva,
          comment.total_costo,
          comment.user,
        ].some((v) => String(v ?? "").toLowerCase().includes(q))
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "kilos" &&
      sorting.field != "metros" &&
      sorting.field != "piezas" &&
      sorting.field != "numeroOrden" &&
      sorting.field != "total_costo" &&
      sorting.field != "subtotal" &&
      sorting.field != "iva" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "kilos" ||
        sorting.field == "metros" ||
        sorting.field == "piezas" ||
        sorting.field == "numeroOrden" ||
        sorting.field == "total_costo" ||
        sorting.field == "subtotal" ||
        sorting.field == "iva" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "kilos" ||
        sorting.field == "metros" ||
        sorting.field == "piezas" ||
        sorting.field == "numeroOrden" ||
        sorting.field == "total_costo" ||
        sorting.field == "subtotal" ||
        sorting.field == "iva" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedProveedor,
    activo,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

function QRGen(idCompra) {
  axios
    .get(`${URL_INVENTARIOS}/compras/${idCompra}`, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    })
    .then((response) => {
      const allRollos = response.data;

      const doc = new jsPDF("l", "mm", [100, 50]);

      const M = 4;
      const PAGE_H = 50;
      const LEFT_COL_W = 60;
      const RIGHT_COL_X = M + LEFT_COL_W + 2;

      allRollos
        .sort((a, b) => (a.captura > b.captura ? 1 : -1))
        .forEach((r, idx) => {
          // Logos
          try {
            const logo1 = new Image();
            logo1.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
            doc.addImage(logo1, "PNG", M, M, 18, 6);
          } catch (_) {}

          try {
            const logo2 = new Image();
            logo2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            doc.addImage(logo2, "PNG", M + 20, M, 14, 6);
          } catch (_) {}

          // QR
          const qrData = qrcode.toDataURL(r?._id ?? "");
          doc.addImage(qrData, "PNG", RIGHT_COL_X, M, 30, 30);

          // Texto dinámico
          const wrap = (txt) =>
            doc.splitTextToSize(String(txt ?? ""), LEFT_COL_W);

          const addTextBlock = (text, y) => {
            const lines = wrap(text);
            doc.text(lines, M, y);
            const h = doc.getTextDimensions(lines).h;
            return y + h + 1;
          };

          let y = M + 11;

          const codigo = r?.telas?.[0]?.codigo ?? "";
          const modelo = r?.telas?.[0]?.nombre ?? "";
          const composicion = r?.telas?.[0]?.composicion ?? "";
          const color = r?.colores?.[0]?.name ?? "";
          const unidad = r?.telas?.[0]?.unidad ?? "";
          const id = r?._id ?? "";
          const cantidad = r?.cantidad ?? "";

          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);

          y = addTextBlock(`Cod: ${codigo}`, y);
          y = addTextBlock(`Mod: ${modelo}`, y);
          y = addTextBlock(`Color: ${color}`, y);
          y = addTextBlock(`Comp: ${composicion}`, y);
          y = addTextBlock(`ID: ${id}`, y);

          // Cantidad: debajo del QR (derecha), negrita, sin "Cant." (como ListadoCompras)
          doc.setFont("helvetica", "bold");
          doc.setFontSize(15);
          const cantTxt = `${cantidad ?? ""} ${unidad ?? ""}`.trim();
          const qrCenterX = RIGHT_COL_X + 15;
          const cantY = M + 30 + 7;
          doc.text(cantTxt, qrCenterX, cantY, { align: "center" });

          if (idx < allRollos.length - 1) {
            doc.addPage([100, 50], "l");
          }
        });

      window.open(doc.output("bloburl"), "_blank");
    })
    .catch(console.error);
}


  function cancelarCompra(idCompra) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Compra!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_COMPRAS_DIRECTAS}Cancel/${idCompra}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Enviado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function cancelarCompraHab(idCompra) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara la Compra!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_COMPRAS_DIRECTAS}CancelHab/${idCompra}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Enviado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  async function jalaFaltantes(
    fecha,
    idProveedores,
    proveedores,
    kilos,
    metros,
    piezas,
    observaciones,
    numero,
    tipo,
    idPDFOC
  ) {
    setNumeroCompra(numero);
    setIdEdit(idPDFOC);

    await axios
      .get(`${URL_COMPRAS_DIRECTAS_ACUMULADOS}/compra/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTelasCompra = response.data;
        let arrayTabla = allTelasCompra
          .map((a) => {
            return {
              id: a._id,
              telas: a.telas[0].nombre,
              color: a.colores[0].name,
              cantidad: a.cantidad,
              faltante: a.faltante,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setArticulosFaltante(dataFinal);

        let totalMts = dataFinal.map((c) => parseFloat(c.faltante));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        setTotalFaltante(TM);

        toggleFaltante();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleChangeInputCantidad = (id, event) => {
    const newArticulosFaltante = articulosFaltante.map((i) => {
      if (id === i.id) {
        i.faltante = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosFaltante(newArticulosFaltante);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalMts = articulosFaltante.map((c) => parseFloat(c.faltante));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalFaltante(TM);
  }

  async function editFaltante() {
    let totalRollos = articulosFaltante.length;

    try {
      await axios
        .patch(
          `${URL_COMPRAS_DIRECTAS}/${idEdit}`,
          {
            total_faltante: totalFaltante,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          articulosFaltante.map((a) => {
            if (a.faltante != 0) {
              axios
                .patch(
                  `${URL_COMPRAS_DIRECTAS_ACUMULADOS}/${a.id}`,
                  {
                    faltante: a.faltante,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Faltante Tela",
                          detalle: `Compra ${idEdit}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 2000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                      });
                  }
                });
            } else {
              totalRollos = totalRollos - 1;
              if (totalRollos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Faltante Tela",
                      detalle: `Compra ${idEdit}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              }
            }
          });
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.compras_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ComprasDirectasCreate"
                >
                  Nueva Compra
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Compra
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Compra</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Compras</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Proveedores</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.razon_social}</option>;
                  })}
              </Input>
            </Col>

            <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.activo}</td>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.numeroOrden}</td>
                      {/* <td>{a.observacionesOrden}</td> */}
                      <td>{a.proveedores}</td>
                      {/* <td>{new Intl.NumberFormat("en-US").format(a.kilos)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.metros)}</td> */}
                      <td>{new Intl.NumberFormat("en-US").format(a.piezas)}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subtotal)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.iva)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_costo)}
                      </td>
                      <td>{a.user}</td>
                      <td>
                        <div>
                          {/* <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={(e) =>
                              PDFOCResumen(
                                a.fecha,
                                a.proveedores,
                                a.numero,
                                a.iva,
                                a.total_costo,
                                a._id
                              )
                            }
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button> */}
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              jalaPDFOC(
                                a.fecha,
                                a.proveedores,
                                a.numero,
                                a.iva,
                                a.total_costo,
                                a._id
                              )
                            }
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>
                          {a.activo == "Si" ? (
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.fecha,
                                  a.factura_proveedor,
                                  a.observaciones,
                                  a.numero,
                                  a.pais_origen,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                          ) : undefined}

                          {a.tipo == "Tela" && a.activo == "Si" ? (
                            <>
                              <Button
                                size="sm"
                                className="btn"
                                color="success"
                                onClick={(e) => QRGen(a._id)}
                              >
                                <i class="fas fa-qrcode"></i>
                              </Button>
                              {a.activo == "Si" && user.cancelar_compra ? (
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={(e) => cancelarCompra(a._id)}
                                >
                                  <i class="fas fa-ban"></i>
                                </Button>
                              ) : undefined}
                              <Button
                                size="sm"
                                className="btn"
                                color="primary"
                                onClick={(e) =>
                                  jalaFaltantes(
                                    a.fecha,
                                    a.idProveedores,
                                    a.proveedores,
                                    a.kilos,
                                    a.metros,
                                    a.piezas,
                                    a.observaciones,
                                    a.numero,
                                    a.tipo,
                                    a._id
                                  )
                                }
                              >
                                <i class="fas fa-undo-alt "></i>
                              </Button>
                            </>
                          ) : undefined}

                          {/* Cancelacion Habilitacion */}
                          {a.activo == "Si" && a.tipo == "Habilitacion" && user.cancelar_compra ? (
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={(e) => cancelarCompraHab(a._id)}
                                >
                                  <i class="fas fa-ban"></i>
                                </Button>
                              ) : undefined}
                        </div>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Compra # {numero_compra}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>

            <Col md={4}>
              <Label>Factura Proveedor</Label>
              <Input
                type="text"
                placeholder="Factura Proveedor"
                value={factura_proveedor}
                required
                onChange={(e) => {
                  setFacturaProveedor(e.target.value);
                }}
              />
            </Col>

            <Col md={4}>
              <Label>Pais Origen</Label>
              <Input
                type="text"
                placeholder="Pais Origen"
                value={pais_origen}
                required
                onChange={(e) => {
                  setPaisOrigen(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editCompras}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalFaltante} toggle={toggleFaltante}>
        <ModalHeader toggle={toggleFaltante}>
          <h4>Faltante Compra # {numero_compra}</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <Row>
              <Col md={3}>Tela</Col>
              <Col md={3}>Color</Col>
              <Col md={3}>Cantidad Compra</Col>
              <Col md={3}>Cantidad Faltante</Col>
            </Row>
            <tbody>
              {articulosFaltante.map((a) => {
                {
                  return (
                    <Row>
                      <Col md={3}>{a.telas}</Col>
                      <Col md={3}>{a.color}</Col>
                      <Col md={3}>{(a.cantidad).toFixed(2)}</Col>
                      <Col md={3}>
                        <Input
                          bsSize="sm"
                          name="faltante"
                          type="number"
                          placeholder="Faltante"
                          value={a.faltante}
                          required
                          onChange={(event) =>
                            handleChangeInputCantidad(a.id, event)
                          }
                        />
                      </Col>
                    </Row>
                  );
                }
              })}
            </tbody>
          </Table>
          <Row>
            <Col md={6}></Col>
            <Col md={3}>
              <Label>Total</Label>
            </Col>
            <Col md={3}>
              <Label>{totalFaltante}</Label>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editFaltante}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoComprasDirectas;
